<template>
  <div class="tableList">
    <div class="title">
      我要送拍
    </div>
    <div class="tables">
      <div class="warning">
        请如实填写您的藏品信息，我们会为您推送至各大拍卖行，同时经您同意后，您的藏品还有机会在雅昌平台上拍。
      </div>
      <!-- <div class="formTit">
        <h4>请填写送拍信息</h4>
        <span
          >（标有
          <em style="color:red;">*</em>
          为必填项）</span
        >
      </div> -->
      <div class="form">
        <el-form :model="form" :rules="rules" ref="formRef" label-width="175px">
          <!-- <el-form-item label="机构选择：">
            <div class="checkbox">
              可点击多选
              <el-checkbox
                :indeterminate="isIndeterminate"
                v-model="checkAll"
                @change="handleCheckAllChange"
              >
                全选
              </el-checkbox>
            </div>
            <div class="checkbox-group">
              <el-checkbox-group v-model="checkedCities">
                <el-checkbox-button
                  v-for="city in cities"
                  :label="city"
                  :key="city"
                >
                  {{ city }}
                </el-checkbox-button>
              </el-checkbox-group>
            </div>
          </el-form-item> -->
          <el-form-item label="拍品图片：" prop="CoverPic">
            <cpn-upload ref="uploadRef" :max="1" @on-uploaded="uploadFun" />
          </el-form-item>
          <el-form-item label="拍品名称：" prop="WorkName">
            <el-input
              v-model="form.WorkName"
              placeholder="（必填）请填写"
              maxlength="30"
            ></el-input>
          </el-form-item>
          <el-form-item label="拍品类别：" prop="SortName">
            <el-select v-model="form.SortName">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="拍品标签：" prop="WorkMark">
            <el-input
              v-model="form.WorkMark"
              placeholder="请填写"
              maxlength="16"
            ></el-input>
          </el-form-item>
          <el-form-item label="拍品尺寸：" prop="SizeInfo">
            <el-input
              v-model="form.SizeInfo"
              placeholder="（必填）请填写"
              maxlength="16"
            ></el-input>
          </el-form-item>
          <el-form-item label="自报价：" prop="SoldPrice">
            <el-input
              v-model="form.SoldPrice"
              placeholder="（必填）请填写"
              maxlength="16"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系电话：" prop="Phone">
            <el-input
              v-model="form.Phone"
              placeholder="（必填）请填写"
              maxlength="16"
            ></el-input>
          </el-form-item>
          <el-form-item label="姓名：" prop="ConnectName">
            <el-input
              v-model="form.ConnectName"
              placeholder="（必填）请填写"
              maxlength="8"
            ></el-input>
          </el-form-item>
          <el-form-item label="地址：" prop="Place">
            <el-input
              v-model="form.Place"
              placeholder="（必填）请填写"
              maxlength="30"
            ></el-input>
          </el-form-item>
          <el-form-item label="邮箱：" prop="Email">
            <el-input
              v-model="form.Email"
              placeholder="（必填）请填写"
              maxlength="50"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="operation">
      <div class="reset">
        <el-button type="info" @click="resetForm">重新填写</el-button>
      </div>
      <div class="submit">
        <el-button type="success" @click="submitForm">确认填写</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { postZoneSend } from "@/api/auction";
import { cityOptions, options } from "./list";
import cpnUpload from "@/views/admin/adminiStrator/pages/cpn/upload/UploadFile";
export default {
  name: "tableList",
  components: {
    cpnUpload,
  },
  data() {
    return {
      checkAll: false,
      isIndeterminate: true,
      cities: cityOptions,
      options,
      checkedCities: [],
      form: {
        WorkName: "",
        CoverPic: "",
        SortName: "",
        WorkMark: "",
        SizeInfo: "",
        SoldPrice: "",
        Phone: "",
        ConnectName: "",
        Place: "",
        Email: "",
      },
      rules: {
        WorkName: [{ required: true, message: "请正确输入", trigger: "blur" }],
        WorkMark: [{ required: true, message: "请正确输入", trigger: "blur" }],
        SortName: [
          { required: true, message: "请正确输入拍品类别", trigger: "blur" },
        ],
        SizeInfo: [
          { required: true, message: "请正确输入拍品尺寸", trigger: "blur" },
        ],
        SoldPrice: [
          { required: true, message: "请正确输入自报价", trigger: "blur" }
        ],
        Phone: [
          { required: true, message: "请正确输入联系电话", trigger: "blur" },
          {
            pattern: /^[0-9-\_]+$/,
            message: "号码格式不正确~",
            trigger: "blur",
          },
        ],
        ConnectName: [
          { required: true, message: "请正确输入姓名", trigger: "blur" },
        ],
        Place: [{ required: true, message: "请正确输入地址", trigger: "blur" }],
        Email: [
          { required: true, message: "请正确输入邮箱", trigger: "blur" },
          {
            pattern: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/,
            message: "请正确按照格式输入",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    if(!this.getCookie('_at_pt_0_')) this.gotoLogin();
  },
  methods: {
    handleCheckAllChange(value) {
      this.checkedCities = value ? cityOptions : [];
      this.isIndeterminate = false;
    },
    submitForm() {
      this.$refs.formRef.validate((isOk) => {
        if (!isOk) return;
        postZoneSend(this.form).then((res) => {
          if (res.code !== 0) return this.$message.error("提交失败");
          this.$confirm('送拍信息已提交，如机构有意向会与你联系。拍卖合作需谨慎，请提前确认合作方身份，杜绝诈骗！',{
            cancelButtonText: '退出',
            confirmButtonText: '继续送拍',
            confirmButtonColor: '#18BD6F'
          })
            .then(_ => {
              this.resetForm();
            })
            .catch(_ => {
              this.$router.go(-1)
            });
        });
      });
    },
    resetForm() {
      this.$refs.uploadRef.fileList = []
      this.$refs.formRef.resetFields();
    },
    uploadFun(e) {
      if (!e) return;
      this.form.CoverPic = e[0].path;
    },
    getCookie(name) {
      var arr,
        reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
      if ((arr = document.cookie.match(reg))) {
        return arr[2];
      } else {
        return null;
      }
    },
    gotoLogin: function() {
      window.location.href =
        "//passport.artron.net/login?appId=1&redirect=" +
        encodeURIComponent(window.location.href);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
